export default {
    tool: "fa-wrench",
    data_input: "fa-file-o",
    data_collection_input: "fa-folder-o",
    subworkflow: "fa-sitemap fa-rotate-270",
    pause: "fa-pause"
};



// WEBPACK FOOTER //
// ./galaxy/scripts/mvc/workflow/workflow-icons.js